/** 사이트 currency 미설정 시 기본값 (백엔드 SiteAmountRules와 동일: 빈 값 = USD) */
export const DEFAULT_CURRENCY = '$'
export const DEFAULT_SITE_NAME = '헬퍼 카지노'

function parseSiteImg (siteInfo) {
  const value = siteInfo && siteInfo.site_img
  if (value && typeof value === 'object') {
    return {
      logo: value.logo != null ? String(value.logo).trim() : '',
      banner: value.banner != null ? String(value.banner).trim() : '',
      loading: value.loading != null ? String(value.loading).trim() : ''
    }
  }

  const raw = value != null ? String(value).trim() : ''
  if (!raw) {
    return { logo: '', banner: '', loading: '' }
  }

  if (raw.startsWith('{')) {
    try {
      const parsed = JSON.parse(raw)
      return {
        logo: parsed && parsed.logo != null ? String(parsed.logo).trim() : '',
        banner: parsed && parsed.banner != null ? String(parsed.banner).trim() : '',
        loading: parsed && parsed.loading != null ? String(parsed.loading).trim() : ''
      }
    } catch (e) {
      return { logo: raw, banner: '', loading: '' }
    }
  }

  return { logo: raw, banner: '', loading: '' }
}
export function resolveSiteLogoUrl (siteInfo) {
  if (!siteInfo) return ''
  const { logo } = parseSiteImg(siteInfo)
  return logo || ''
}

export function resolveSiteBannerUrl (siteInfo) {
  if (!siteInfo) return ''
  const { banner } = parseSiteImg(siteInfo)
  return banner || ''
}

export function resolveSiteLoadingLogoUrl (siteInfo) {
  if (!siteInfo) return ''
  const { loading } = parseSiteImg(siteInfo)
  return loading || ''
}

export function getTelegramInquiryBannerUrl (locale) {
  const suffix = String(locale || 'ko').toLowerCase() === 'ko' ? 'ko' : 'en'
  return `/assets/images/telegram-inquiry_${suffix}.png`
}

export function resolveSiteCurrency (siteInfo) {
  const raw = siteInfo && siteInfo.currency != null
    ? String(siteInfo.currency).trim()
    : ''
  return raw || DEFAULT_CURRENCY
}

export function isUsdSiteCurrency (siteInfo) {
  const raw = resolveSiteCurrency(siteInfo)
  const code = raw.toUpperCase()
  return raw === '$' || code === 'USD'
}

export function resolveSiteName (siteInfo) {
  const raw = siteInfo && siteInfo.name != null
    ? String(siteInfo.name).trim()
    : ''
  return raw || DEFAULT_SITE_NAME
}

export function applySiteDocumentTitle (siteInfo) {
  if (typeof document === 'undefined') return
  const raw = siteInfo && siteInfo.name != null
    ? String(siteInfo.name).trim()
    : ''
  document.title = raw
}
